function EmptyIcon() {
  return <svg height="19" viewBox="0 0 19 19" width="19" />;
}

export default EmptyIcon;
